export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
          如果你有电影推荐、片源建议或合作意向，欢迎通过以下方式与我们取得联系。
          菲菲影院期待听到每一位影迷的声音。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:contact@feifeicinema.com"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-lg"></i>
            发送邮件
          </a>
          <span className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 rounded-lg text-sm border border-background-300 whitespace-nowrap">
            <i className="ri-wechat-line text-lg text-green-500"></i>
            微信公众号：菲菲影院
          </span>
        </div>
      </div>
    </section>
  );
}